import React from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

/** Preserve both Analytics bookmarks after merging reports into the dashboard. */
export default function AnalyticsDashboard() {
  return <Navigate to={paths.admin.dashboard} replace />;
}
